module.exports = __webpack_public_path__ + "static/img/MC.2f979dad.png";